import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Template from "./template";

const dataQuery = graphql`
  query {
    homeJson {
      hero {
        title
        text
        image {
          src {
            publicURL
          }
          alt
        }
        cta_label
        cta_link
        text2
      }
    }
  }
`;

function Hero() {
  const {
    homeJson: { hero }
  } = useStaticQuery(dataQuery);

  return <Template data={hero} />;
}

export default Hero;
